import React from "react";
import { KeyTitle, CustomizedTH } from "./style";
import PropTypes from "prop-types";

const CustomizedTable = ({ children, headTitles, alignTitles }) => {
    return (
        <div className="table-responsive">
            <table className="table">
                <thead>
                    <tr>
                        {headTitles.map((text, idx) => (
                            <CustomizedTH
                                key={`${text}-${idx}`}
                                alignTitles={alignTitles}
                                className={"border-0"}
                            >
                                <KeyTitle>{text}</KeyTitle>
                            </CustomizedTH>
                        ))}
                    </tr>
                </thead>
                <tbody>{children}</tbody>
            </table>
        </div>
    );
};

CustomizedTable.propTypes = {
    headTitles: PropTypes.array,
    children: PropTypes.element,
    alignTitles: PropTypes.string
};

export default CustomizedTable;
